(() => {
  if (window.gugaRefreshLoaded) return;
  window.gugaRefreshLoaded = true;
  const roots = () => [...document.querySelectorAll('[data-guga-section]')];
  const stringsFor = root => JSON.parse(root.querySelector('[data-guga-strings]').textContent);
  async function currentStock(root) {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', root.dataset.gugaSection);
    url.searchParams.set('_guga_stock', Date.now());
    // Hidden pages return the Page JSON for Accept: application/json instead of the
    // Section Rendering API response, so request text/html. The body is still the
    // sections JSON envelope.
    const response = await fetch(url, {headers: {'Accept': 'text/html'}, cache: 'no-store'});
    if (!response.ok) throw new Error(stringsFor(root).error);
    const sections = await response.json();
    const html = sections[root.dataset.gugaSection];
    if (!html) throw new Error(stringsFor(root).error);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const ids = new Set([...doc.querySelectorAll('[data-guga-card]')].map(card => card.dataset.variantId));
    let removed = false;
    root.querySelectorAll('[data-guga-card]').forEach(card => {
      if (!ids.has(card.dataset.variantId)) {
        card.remove();
        removed = true;
      }
    });
    const dependentIds = new Set([...doc.querySelectorAll('[data-guga-dependent]')].map(item => item.dataset.gugaDependent));
    root.querySelectorAll('[data-guga-dependent]').forEach(item => {
      if (!dependentIds.has(item.dataset.gugaDependent)) item.remove();
    });
    root.querySelectorAll('[data-guga-group]').forEach(group => {
      const emptyGroup = !group.querySelector('[data-guga-card]');
      group.hidden = emptyGroup;
      root.querySelectorAll(`[data-guga-group-link="${group.dataset.gugaGroup}"]`).forEach(link => { link.hidden = emptyGroup; });
    });
    const empty = !root.querySelector('[data-guga-card]');
    root.querySelector('[data-guga-empty]').hidden = !empty;
    root.querySelector('[data-guga-guide]').hidden = empty;
    if (removed) root.querySelector('[data-guga-status]').textContent = stringsFor(root).unavailable;
    return ids;
  }
  document.addEventListener('landing-cart:error', event => {
    if (event.detail?.status !== 422) return;
    const root = event.target.closest('[data-guga-section]');
    if (root) currentStock(root).catch(() => {});
  });
  let lastStockCheck = 0;
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    const now = Date.now();
    if (now - lastStockCheck < 60000) return;
    lastStockCheck = now;
    roots().forEach(root => currentStock(root).catch(() => {}));
  });
})();
